import urlConfig from "../config/urlConfig.js";

var authority = urlConfig.authority;
var erp = urlConfig.erp;
var pos = urlConfig.pos;
var adminApi = {
  uploadInoutBill:'/restAssuredOnTheCode/uploadInoutBill',
  getCodeDetailByBatchNumber:'/restAssuredOnTheCode/getCodeDetailByBatchNumber',
  deleteCode:'/restAssuredOnTheCode/deleteCode/',
  gyOrder:{
    getStoreName:'/gyOrder/getStoreName',
    getOrderList:'/gyOrder/getOrderList',
    getOrderListExport:'/gyOrder/getOrderListExport',
    getOrderDetail:'/gyOrder/getOrderDetail/',
    retry:'/gyOrder/retry/',
    lookLogLogistics:'/gyOrder/lookLogLogistics/',
    cancel:'/gyOrder/cancel/',
    getShippingOrderList:'/gyOrder/getShippingOrderList',
    getShippingOrderListExport:'/gyOrder/getShippingOrderListExport',
    orderShipping:'/gyOrder/orderShipping',
    generateLogisticsNumber:'/gyOrder/generateLogisticsNumber',
    editOrder:'/gyOrder/editOrder',
    importBackLogisticsBill:'/gyOrder/importBackLogisticsBill',
    editReturnOrder:'/gyOrder/editReturnOrder',
    printLogisticsNumber:'/gyOrder/printLogisticsNumber/',
    printPickingList:'/gyOrder/printPickingList/',
    getReturnOrderList:'/gyOrder/getReturnOrderList',
    getOrderReturnDetail:'/gyOrder/getOrderReturnDetail/',
    handleOrderReturn:'/gyOrder/handleOrderReturn/',
    codeNumCheck:'/restAssuredOnTheCode/codeNumCheck',
    getOrderReturnListExport:"/gyOrder/getOrderReturnListExport",
  },


  getOrderChannelType:'/crm/orderInfo/getOrderChannelType',
  // 获取提交令牌
  getSubmitToken: erp + "/createUrlToken/createToken",
  // 权限管理
  authority: {
    //根据ID 查询
    getStoreById: "/erpStoreInfo/getStoreById/",
    //修改机构
    modifyErpStoreInfo: "/erpStoreInfo/modifyErpStoreInfo",
    //添加机构
    addErpStoreInfo: "/erpStoreInfo/addErpStoreInfo",
    //机构管理审批
    approveErpStoreInfo: "/erpStoreInfo/approveErpStoreInfo",
    //机构管理列表
    erpStoreInfoshowList: "/erpStoreInfo/showList",
    //机构管理下拉列表
    erpStoreInfoshowAllList: "/erpStoreInfo/showAllList",
    //[机构管理]—根据父id查询所有子机构
    selectValidStoresByParentId: "/erpStoreInfo/getStoresByParentId/",
    // 系统用户列表展示
    sysUserList: "/adminmanager/su/showList",
    // 审核角色列表展示
    sysRoleShow: "/sysRolePwoerFnAudit/showList",
    // 审核角色详情
    lookDetail: "/sysRolePwoerFnAudit/lookDetail",
    // 系统用户删除
    sysUserDel: "/adminmanager/su/del/",
    // 系统用户新增
    sysAdd: "/adminmanager/su/addUser",
    // 系统用户修改
    sysUpdate: "/adminmanager/su/modifyUser",
    // 获取用户角色
    getRoleList: "/role/all",
    // 添加角色审核
    addRoleAudit: "/sysRolePwoerFnAudit/addSysRolePwoerFnAudit",
    // 查看修改内容
    lookRoleDetail: "/sysRolePwoerFnAudit/lookRoleDetail",
    // 角色审核
    auditApply: "/sysRolePwoerFnAudit/auditApply",
    // 获取角色管理列表
    sysRoleList: "/role/su/showList",
    // 角色删除
    sysRoleDel: "/role/su/del/",
    // 添加角色
    addRole: "/role/su/addRole",
    // 修改角色
    modifyRole: "/role/su/modifyRole",
    //根据角色id查询角色
    searchRole: "/role/su/queryRole",
    // 重置密码
    resetPassword: "/adminmanager/su/resetPassword/",
    // 用户解锁，锁定
    accountLock: "/adminmanager/accountLock",
    //获取门店部门列表
    selectValidByParentId: "/erpStoreInfo/selectValidByParentId/",
    //[资源权限管理]—资源权限查询
    selectRelationByModel: "/erpResourcesAuth/selectRelationByModel",
    //[资源权限管理]—用户拥有的资源权限查询
    selectAuthRoleByModel: "/erpResourceAuthRole/su/selectAuthRoleByModel",
    //[资源权限管理]—批量修改系统拥有的资源权限
    modifyresourceAuthRole: "/erpResourceAuthRole/su/modifyresourceAuthRole",
    //营销活动门店
    selectValidByParentIdToAct: "/erpStoreInfo/selectValidByParentIdToAct",
    //查询所有公司接口
    sysCompanyList: "/sysCompany/all",
    //查询所有公司所属门店
    selectListByCompanyId: "/erpStoreInfo/selectListByCompanyId/"
  },
  upload: {
    // 导出模板
    importLogisticsTemplate: '/crm/wellenInfo/importLogisticsTemplate',
    // 导出物流信息
    exportWaveTime: '/crm/wellenInfo/exportWaveTime/',
    uploadFile: erp + "/multipleUploadFile/doUpload/",
    //删除文件
    uploadDel: erp + "/erpFileUplaod/file/delete",
    //获取验证码
    getPhonVerifyCode: authority + "/login/getPhonVerifyCode/",
    // 会员获取验证码
    getPhonVerifyCodeByCustomer:
      authority + "/login/getPhonVerifyCodeByCustomer/",
    // 确认验证码
    affirmVerify: authority + "/login/affirmVerify/",
    //修改密码
    changePassword: authority + "/adminmanager/changePassword/",
    //高拍仪上传图片
    uploadImage: pos + "/fileUpload/img/uploadImage",
    //退出接口
    loginOut: authority + "/login/loginOut"
  },
  // 首页改造
  homerenovation: {
    // crm登录
    // dologin: "common/dologin",
    dologin: "login/dologin",
    // 登录
    userLogin: authority + "/login/dologin",
    // 最近浏览记录功能列表显示
    showBrowseList: authority + "/erpFunctionBrowse/showBrowseList",
    // 新增最近浏览的功能记录调用说明
    addErpFunctionBrowse: authority + "/erpFunctionBrowse/addErpFunctionBrowse",
    // 功能收藏列表功能位置变换
    modifyFunctionCollSort:
      authority + "/erpFunctionCollection/modifyFunctionCollSort",
    // 根据对象删除(取消收藏)
    delByModel: authority + "/erpFunctionCollection/delByModel/",
    // 收藏功能新增
    addErpFunctionCollection:
      authority + "/erpFunctionCollection/addErpFunctionCollection",
    // 获取用户收藏的功能
    getUserCollcetionFunction:
      authority + "/erpFunctionCollection/getUserCollcetionFunction",
    //消息列表查询
    showList: erp + "/erpMessageSend/showList",
    //发送消息
    addErpMessageSend: erp + "/erpMessageSend/su/addErpMessageSend",
    //根据消息id查看消息
    selectById: erp + "/erpMessageSend/selectById/",
    //根据消息id修改回执状态
    updateReadStatus: erp + "/erpMessageSend/updateReadStatus/",
    //通过机构分组查询用户
    getUsersByStore: authority + "/adminmanager/getUsersByStore",
    //门店查询 预警提示
    getWarningCenterNumber: pos + "/posWarningCenter/getWarningCenterNumber",
    //根根消息id查看回执详情
    selectViewDetailsById: erp + "/erpMessageSend/selectViewDetailsById/",
    //删除消息
    deleteMessageById: erp + "/erpMessageSend/su/deleteMessageById/"
  },
  //文件导出管理
  fileExportManage: {
    // [excel导出]—excel导出列表接口
    showList: pos + "/posExportRecord/su/showList",
    //[excel导出]—excel添加导出记录
    addPosExportRecord: pos + "/posExportRecord/su/addPosExportRecord",
    // [excel导出]—excel文件下载
    downloadExcel: erp + "/erpExportRecord/exportExcel/"
  },
  //通用接口
  marketing: {
    //获取所有角色
    getAllUser: "/commonAction/getAllUser",
    //获取门店+部门
    selectValidStoresByParentId: "/erpStoreInfo/selectValidStoresByParentId/",
    // 根据code获取下拉列表
    getDataByCode: "/erpDataDictionary/findByParentDataCode/",
    // 根据企业首营字段模糊查询
    getEntFirstByData: "/erpEntFirstPractice/findSimilarEnterprise",
    //[机构管理]—根据父id查询所有有效子部门（去除总部）
    selectDept: "/erpStoreInfo/selectDept",
    //[通用接口]—根据角色code查询本门店下的用户
    getUserByRoleCode: "/commonAction/getUserByRoleCode",
    //[通用接口]—根据角色code查询本门店下的用户
    prescriptRoleCode: "/commonAction/getUserByRoleCode/",
    getAdminmanager: "/adminmanager/su/showList"
  },
  //CRM订单
  CRMORDER: {
    // 管易导入
    orderImport: '/gyKntOrderController/orderImport',
    // 管易列表
    orderSelect: '/gyKntOrderController/orderSelect',
    // 管易列表导出
    orderExport: '/gyKntOrderController/orderExport',
    // 触发
    push: 'push/',
    // 打印面单接口
    printFaceSheet: '/oms/deliveryManagement/printFaceSheet/',
    // 打印拣货单接口：
    printPickingList: '/oms/deliveryManagement/printPickingList/',
    // 打印商品清单接口：
    printGoodsList: '/oms/deliveryManagement/printGoodsList/',
    // 管易手动重试列表
    retrylist: '/guanyi/orderInfo/retrylist',
    // 导出
    guanyiexcelExport: '/guanyi/orderInfo/excelExport',
    // 重试
    invoiceRetry: '/guanyi/orderInfo/invoiceRetry',
    // 管易手动重试列表查询条件--账套列表
    getAccountlist: '/guanyi/orderInfo/getAccountlist',
    // 管易手动重试列表查询条件--单据类型列表
    getDataTypelist: '/guanyi/orderInfo/getDataTypelist',
    // 管易手动重试列表查询条件--店铺名称列表
    getShopNamelist: '/guanyi/orderInfo/getShopNamelist',
    // 导入退回物流单好
    importBackLogisticsBill: '/crm/orderInfo/importBackLogisticsBill',
    // 批量修改业务类型
    batchEditorBusinessType: '/crm/orderInfo/batchEditorBusinessType',
    // 查看物流信息
    selectLogisticsRoutInfo: '/crm/sfexpress/waybills/selectLogisticsRoutInfo/',
    // 一键生成
    generateWavePicking: '/crm/templateExpress/generateWavePicking',
    /*基础配置*/
    excelExportTemplates: 'crm/backInfo/excelExportTemplate',
    //快递业务类型
    //快递业务类型_新增:传递参数快递公司ID【companyId】
    addBusiness: "crm/basicSet/addBusiness",
    // 快递业务类型_业务类型列表
    showBusiness: "crm/basicSet/showBusiness",
    // 快递业务类型_设为默认: 参数【CrmExpressBusiness.id】
    settingBusiness: "crm/basicSet/settingBusiness/",
    // 查询顺丰
    selectMonthlyCard: 'crm/basicSet/selectMonthlyCard',
    // 设置默认
    setDefaultSFMonthlyCard: 'crm/basicSet/setDefaultSFMonthlyCard/',
    //快递业务类型_修改
    updateBusiness: "crm/basicSet/updateBusiness",
    // 快递业务类型_删除: 参数【CrmExpressBusiness.id】
    deleteBusiness: "crm/basicSet/deleteBusiness/",
    // 快递业务类型_修改查询:参数【CrmExpressBusiness.id】
    selectBusiness: "crm/basicSet/selectBusiness/",
    // 订单导入
    importOrder: "crm/fileController/externalOrderImport/",
    // 订单模板导出
    exportOrderModule: "/crm/fileController/exportTemplate/",
    // 生成物流单号
    createSingleNumber: 'crm/sfexpress/waybills/placeOrder/',
    // 打印面单(波次)
    printWaybill: 'crm/sfexpress/waybills/printSurfaceSingle/',
    // 打印回调(波次)
    printCallBack: 'crm/sfexpress/waybills/printCallback/',
    // 打印面单(订单)
    printWaybillOrder: '/crm/orderInfo/printingSingle/',
    // 打印回调(订单)
    printCallBackOrder: '/crm/orderInfo/printCallback/',
    // 血糖仪 绑定 数据 查询
    logisticsSingle: '/crm/wellenInfo/scanning/',
    //血糖仪绑定
    bindingXTY: '/crm/wellenInfo/bindingXTY/',
    //部门配置
    //同步部门
    syncSenderInfo: "crm/basicSet/syncSenderInfo",
    // CRM部门配置_新增
    addSenderInfo: "crm/basicSet/addSenderInfo",
    // CRM部门配置_删除:参数为crmSenderInfo.id
    deleteSenderInfo: "crm/basicSet/deleteSenderInfo/",
    //CRM部门配置_修改查询: 参数为crmSenderInfo.id
    selectSenderInfo: "crm/basicSet/selectSenderInfo/",
    //CRM部门配置_信息列表:
    showSenderInfo: "crm/basicSet/showSenderInfo",
    showSenderInfo2: "crm/basicSet/showSenderInfo2",
    // CRM部门配置_修改
    updateSenderInfo: "crm/basicSet/updateSenderInfo",
    // 双击修改数据
    doubleSFUpdate: "crm/templateExpress/doubleSFUpdate",
    doubleYTUpdate: "crm/templateExpress/doubleYTUpdate",
    doubleYZUpdate: "crm/templateExpress/doubleYZUpdate",
    doubleZTUpdate: "crm/templateExpress/doubleZTUpdate",
    // 取消（三个快递模板通用此接口）：订单状态只能是【待导入单号】，【待同步】
    cancelOrderInfo: "crm/templateExpress/cancelOrderInfo/",

    /*产品管理*/
    // 查询所有产品
    productInfoShowList: "crm/productInfo/showList",
    // 删除商品
    deleteProduct: "crm/productInfo/deleteProduct/",
    // 修改商品
    updateProduct: "crm/productInfo/updateProduct",
    // 添加商品
    addProduct: "crm/productInfo/addProduct",
    // ID查询商品
    selectById: "crm/productInfo/selectById/",
    // 套餐列表查询
    showMealInfo: "crm/mealInfo/showMealInfo",
    // 根据 ID 查询套餐信息
    selectByMealId: "crm/mealInfo/selectByMealId/",
    // 添加套餐
    addMealInfo: "crm/mealInfo/addMealInfo",
    // 删除套餐
    deleteMeal: "crm/mealInfo/deleteMeal/",
    // 修改套餐商品信息
    updateMeal: "crm/mealInfo/updateMeal",

    /*发货管理*/
    //快递——数据列表
    showSFExpress: "crm/templateExpress/showSFExpress",
    showYTExpress: "crm/templateExpress/showYTExpress",
    showYZExpress: "crm/templateExpress/showYZExpress",
    showZTExpress: "crm/templateExpress/showZTExpress",
    //导出Excel
    exportSFExpress: "crm/templateExpress/exportSFExpress",
    exportYTExpress: "crm/templateExpress/exportYTExpress",
    exportYZExpress: "crm/templateExpress/exportYZExpress",
    exportZTExpress: '/crm/templateExpress/exportZTExpress',
    /*订单管理*/
    // 作废
    deleteOrderInfo: "/crm/sfexpress/waybills/orderCancell/",
    // 删除
    orderDelete: "/gyKntOrderController/orderDelete/",
    // 重试
    orderOutboundRetry: "/gyKntOrderController/orderOutboundRetry/",
    // 查看订单信息
    selectByOrderId: "crm/orderInfo/selectByOrderId/",
    // 订单查询
    showOrderInfo: "/crm/orderInfo/showOrderInfo",
    // 修改订单详情
    updateOrder: "crm/orderInfo/updateOrder",
    // 导出Excel
    excelExport: "crm/orderInfo/excelExport",

    /*波次管理*/
    // 查询波次列表
    showWellenList: "crm/wellenInfo/showWellenList",
    //创建波次
    addWellen: "crm/templateExpress/addWellen",
    // 查看波次详细信息----参数为波次ID
    selectWellenInfo: "crm/wellenInfo/selectWellenInfo/",
    // 出单记录：波次状态为【2：待打印拣货单；3：已完成】才可操作----查询参数为【波次ID】
    cissueLog: '/crm/wellenInfo/issueLog/',
    // issueLog: "crm/wellenInfo/issueLog/",
    issueLog: '/crm/wellenInfo/failingLog/',
    // 打印总拣单：需传参数为【波次编号：wellenNo】只有已同步订单(波次状态)打印生效，按指定订单合并品种批号导出。
    printSumCheck: "crm/wellenInfo/printSumCheck/",
    // 打印分拣单：需传参数为【波次编号：wellenNo】只有已同步订单(波次状态)打印生效，按指定订单合并品种批号导出。
    printSortingCheck: "crm/wellenInfo/printSortingCheck/",
    //导出excel
    exportWellenTemplate: "crm/wellenInfo/exportTemplate",
    //增加打印次数
    printTemplateAddOne: "crm/wellenInfo/printTemplateAddOne/",
    //作废波次单
    cancellationWellen: "crm/wellenInfo/cancellationWellen/",
    // 自动请货出库 :参数为波次ID
    goodsOutBound: "crm/rpcService/goodsOutBound/",
    /*退货管理*/
    //新建退货:订单状态为【已完成】
    // addReturn: "crm/backInfo/addReturn",
    addReturn: 'crm/backInfo/backDataCompile',
    // 退单查询列表：【同步状态：如果订单是已完成的状态，则显示同步成功；否则空白显示】
    // showBackInfo: "crm/backInfo/showBackInfo",
    showBackInfo: 'crm/backInfo/backDataList',
    //新建退货-提取原销售订单{订单状态只能是【已完成的状态】
    originalSellOrder: "crm/backInfo/originalSellOrder",
    // 修改：状态为【0：待收货】才可执行此操作
    updateBackInfo: "crm/backInfo/updateBackInfo",
    //查看退货单
    // selectBackInfo: "crm/backInfo/selectBackInfo/",
    selectBackInfo: 'crm/backInfo/backDataDetail/',
    //导入面单号
    importLogistics: "crm/wellenInfo/importLogistics/",
    // Excel导入退货订单
    excelImportBackOrder: 'crm/backInfo/excelImportBackOrder',
    // 导出退货模板
    excelExportTemplate: "crm/backInfo/excelExportTemplate",
    // 退单日志：状态为【2：已完成】才可执行此操作
    backInfoLog: "crm/backInfo/backInfoLog/",
    //退货作废
    // deleteBackInfo: "crm/backInfo/deleteBackInfo/",
    deleteBackInfo: 'crm/backInfo/backDataDelete/',
    // 确认收货
    submitBackInfo: "crm/backInfo/submitBackInfo",
    // 导入包裹号批量收货
    excelImportTracking: "crm/backInfo/excelImportTracking",
    // 导出Excel
    excelExportBackOrder: "crm/backInfo/excelExportBackOrder",
    // 自动退货入库v{backInfoList}
    // returnTreasury: "crm/rpcService/returnTreasury"
    returnTreasury: 'crm/backInfo/automaticBackData/',
    batchAutomaticBackData: 'crm/backInfo/batchAutomaticBackData',
    // 产品启用禁用
    enableDisable: '/crm/productInfo/enableDisable/',
  },
  // 出库查询
  ProductDeliveryManagement: {
    // 出库查询列表
    outboundDataShow: '/productOutStorage/outboundDataShow',
    // 出库列表明细
    outboundDataDetailShow: '/productOutStorage/outboundDataDetailShow/',
    // 出库导出
    outboundDataDetailExport: '/productOutStorage/outboundDataDetailExport/',
  },
  OMS: {
    // 发货管理--批量发货
    batchDeliver: '/oms/deliveryManagement/sendOrderInfo',
    // 发货管理 -- 打印
    printOrder: '/oms/deliveryManagement/printingCommonMethods',
    // 生成物流订单
    generateDeliveryOrder: '/oms/deliveryManagement/generateLogistics/',
    retryOrder: '/oms/deliveryManagement/reTry/',
    // 批量生成物流订单
    batchGenerateLogisticsCode: '/oms/deliveryManagement/batchGenerateLogisticsCode',
  },
  guanyi: {
    order: {
      deliveryList: "guanyi/order/deliveryList",
      deliveryDetail: "guanyi/order/deliveryDetail/",
      deliveryRetry: "guanyi/order/deliveryRetry",
      deliveryCancelList: "guanyi/order/deliveryCancelList",
      deliveryCancelDetail: "guanyi/order/deliveryCancelDetail/",
      deliveryCancelRetry: "guanyi/order/deliveryCancelRetry",
      tradeReturnList: "guanyi/order/tradeReturnList",
      tradeReturnDetail: "guanyi/order/tradeReturnDetail/",
      tradeReturnRetry: "guanyi/order/tradeReturnRetry",
    }
  }
};
export default adminApi;



// WEBPACK FOOTER //
// ./src/api/adminApi.js